
import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class ReferenceRedirectLine extends Vue {

  @Prop({required: true, default: () => ""})
  label: string;

  @Prop({required: false, default: () => false})
  showRedirect: boolean;

  @Emit("click")
  handleClick() {

  }

}
